// Module
var code = "<svg width=\"588\" height=\"588\" xmlns=\"http://www.w3.org/2000/svg\"> <g> <title>Layer 1</title> <ellipse stroke=\"#4880fa\" stroke-width=\"70\" ry=\"255.99999\" rx=\"255.99999\" id=\"svg_1\" cy=\"292.99999\" cx=\"293.99999\" fill=\"#ffffff\"/> </g> </svg>";
// Exports
module.exports = code;